var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('main',{staticClass:"main",class:'main--' + _vm.$route.params.slug},[_c('div',{class:{
      'section__wrapper--vertical-centered': _vm.$route.params.slug == 'contatti',
    }},[(_vm.page && _vm.page.acf.section)?_c('PageBuilder',{attrs:{"sections":_vm.page.acf.section}}):_vm._e()],1)])}
var staticRenderFns = []

export { render, staticRenderFns }